import type { RadioTextFilterValueType } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';

// @TODO Replace ClickedOperation with OccurredOperation
// import type { OccurredOperation } from '../GenericBloc/GenericConstants/GenericOccurredOptionList';
export enum ClickedOperation {
  OCCURRED = 'occurred',
  DID_NOT_OCCUR = 'did_not_occur',
}

export enum SubFilterClickedKind {
  TEXT = 'text',
  SELECTOR = 'selector',
  PAGE_PATH = 'pagePath',
}

export interface ClickedType {
  operation: ClickedOperation;
  subFilters: ClickedSubFilter[];
}

export interface ClickedSubFilter {
  id: string;
  kind: SubFilterClickedKind;
  value: RadioTextFilterValueType;
}
